export function searchSort<T>(
  items: T[],
  query: string,
  getLabel: (item: T) => string,
): T[] {
  if (!query.trim()) return items;
  const q = query.toLowerCase().trim();
  return [...items].sort((a, b) => {
    const la = getLabel(a).toLowerCase();
    const lb = getLabel(b).toLowerCase();
    const aExact = la === q ? 0 : la.startsWith(q) ? 1 : 2;
    const bExact = lb === q ? 0 : lb.startsWith(q) ? 1 : 2;
    return aExact - bExact;
  });
}
